/**
 * Copy for the sidebar's persistent credits meter (`AppShell.tsx`'s
 * `CreditsMeter`). Kept out of `messages.ts` because a caption on a balance
 * figure is this component's own vocabulary, not the shell chrome's.
 */

import { defineCatalogue } from '../../i18n';

export const creditsMessages = defineCatalogue(
  {
    'meter.empty': 'Sem saldo',
    'meter.coverage': 'Cobre até {date}',
    'meter.stopped': 'Parado desde {date}',
  },
  {
    'meter.empty': 'No balance',
    'meter.coverage': 'Covers until {date}',
    'meter.stopped': 'Stopped since {date}',
  },
);

export const cm = creditsMessages.t;
